// Catalog API. For a client, scope is resolved server-side (send nothing); reps/staff pass
// { store, companyLocationId }.
import { api } from './client.js';

export const fetchCatalogMeta = (scope) =>
  api.get('/catalog/meta', { params: scope || {} }).then((r) => r.data);

export const fetchCatalogProducts = (scope, cursor) =>
  api.get('/catalog/products', { params: { ...(scope || {}), ...(cursor ? { cursor } : {}) } }).then((r) => r.data);

// Full enriched catalog for the focus-and-rail New Order page (colour, RRP, productType, collections).
export const fetchOrderingCatalog = (scope) =>
  api.get('/catalog/ordering', { params: scope || {} }).then((r) => r.data);

// Promotions this client can use, thresholds in `currency` (the order's) — for the next-tier nudge.
export const fetchOrderPromotions = (scope, currency) =>
  api.get('/catalog/promotions', { params: { ...(scope || {}), ...(currency ? { currency } : {}) } }).then((r) => r.data);

// Pre-order shipping estimate for the Review step. Scope goes in the query; units/value + the cart
// line items ([{variantId, quantity}]) go in the body so US quotes use real product weights.
export const fetchShippingEstimate = (scope, { units, value, lines }) =>
  api
    .post('/catalog/shipping-estimate', { units, value, lines: lines || [] }, { params: scope || {} })
    .then((r) => r.data);

// All of a product's Shopify images (lazy-loaded on hover in the order grid).
export const fetchProductImages = (scope, productId) =>
  api.get('/catalog/product-images', { params: { ...(scope || {}), productId } }).then((r) => r.data.images);

// Type-to-search the catalog (newest-first, grouped by style). Returns products with full pricing.
// Pass { ids: [variantId,...] } instead of q to fetch specific products (reorder prefill).
export const searchCatalog = (scope, { q = '', ids = null } = {}) =>
  api
    .get('/catalog/search', { params: { ...(scope || {}), q, ...(ids ? { ids: ids.join(',') } : {}) } })
    .then((r) => r.data);

// XLSX order form download URL (open as a link; the browser sends the auth cookie).
export const orderFormUrl = (scope) => {
  const p = new URLSearchParams();
  if (scope?.store) p.set('store', scope.store);
  if (scope?.companyLocationId) p.set('companyLocationId', scope.companyLocationId);
  const qs = p.toString();
  return `/api/catalog/order-form.xlsx${qs ? `?${qs}` : ''}`;
};

// XLSX current-inventory download URL (active catalog products + units available at the store warehouse).
export const inventoryUrl = (scope) => {
  const p = new URLSearchParams();
  if (scope?.store) p.set('store', scope.store);
  if (scope?.companyLocationId) p.set('companyLocationId', scope.companyLocationId);
  const qs = p.toString();
  return `/api/catalog/inventory.xlsx${qs ? `?${qs}` : ''}`;
};

// Re-upload a filled order workbook → draft order. `params` may include store, companyLocationId,
// companyContactId, onBehalfOfClientUserId.
export const uploadOrderForm = (params, file) => {
  const fd = new FormData();
  fd.append('file', file);
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params || {})) if (v) p.set(k, v);
  const qs = p.toString();
  return api.post(`/catalog/order-form${qs ? `?${qs}` : ''}`, fd).then((r) => r.data);
};
